<mat-form-field appearance="outline" class="w-100">
  <mat-label>{{ label }}</mat-label>
  <input
    type="text"
    matInput
    [formControl]="control"
    [matAutocomplete]="auto"
    [id]="id"
    (focus)="onFocusEvent()"
    autocomplete="new-password"
  />
  <mat-autocomplete
    #nativeElement
    #auto="matAutocomplete"
    [displayWith]="provider.description"
    (optionSelected)="onOptionSelected($event)"
  >
    <mat-option *ngFor="let option of provider.options" [value]="option" [id]="idOption">
      {{ provider.description(option) }}
    </mat-option>
  </mat-autocomplete>
  <mat-icon *ngIf="control.invalid && (control.dirty || control.touched)" matSuffix class="mat-error">error</mat-icon>
  <mat-hint>{{ hint }}</mat-hint>
  <mat-error *ngIf="control.invalid && (control.dirty || control.touched) && errorMessage" [id]="id + '-error'">{{
    errorMessage
  }}</mat-error>
</mat-form-field>
